import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-upgrade-pulsign",
  "use": "app-icon-upgrade-pulsign-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"app-icon-upgrade-pulsign\"><path d=\"M18 18V0h4v18h18v4H22v18h-4V22H0v-4h18z\" fill=\"#C4D4FF\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol